import React from "react";
import { Modal } from "antd-mobile";
import { post } from "../../../../../utils/request";
import api from "../../../../api";
import "./index.less";

class InsuranceDetailModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedIndex: -1,
      loading: false,
      totalAmount: 0,
      insurances: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible && !this.props.visible && nextProps.data) {
      this.fetchInsuranceDetail(nextProps.data.rentalCode);
    }
    if (!nextProps.visible && this.props.visible) {
      this.setState({
        expandedIndex: -1,
        totalAmount: 0,
        insurances: [],
      });
    }
  }

  getHashParams() {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = window.location.hash.split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }
    }
    return ops;
  }

  fetchInsuranceDetail(rentalCode) {
    const urlOps = this.getHashParams();
    this.setState({ loading: true });
    post({
      url: `${api.selectInsurancePremiumByRentalCode}?access_token=${urlOps.access_token}`,
      data: { rentalCode },
    })
      .then((res) => {
        if (res && res.result === "success" && res.data) {
          const { totalActualPremium, insuranceList } = res.data;
          const insurances = (insuranceList || []).map((item) => ({
            type: item.insuranceType,
            periodStart: item.startDate,
            periodEnd: item.endDate,
            paymentMethod: item.paymentWay,
            policyNo: item.insuranceNumber,
            deliveryDate: item.rentDate,
            plannedReturnDate: item.rentDateEnd,
            actualPolicyAmount: item.actualPremium,
            coverageDays: item.insuranceCoverageDay,
            payableInsuranceFee: item.payableInsurancePremium,
          }));
          this.setState({
            totalAmount: totalActualPremium || 0,
            insurances,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  toggleExpand(index) {
    this.setState({
      expandedIndex: this.state.expandedIndex === index ? -1 : index,
    });
  }

  render() {
    const { visible, onClose } = this.props;
    const { expandedIndex, loading, totalAmount, insurances } = this.state;

    return (
      <Modal
        visible={visible}
        onClose={onClose}
        maskClosable={true}
        closable={false}
        transparent
        style={{
          width: "100%",
          position: "fixed",
          bottom: 0,
          left: 0,
          height: "70%",
          borderRadius: "0.08rem 0.08rem 0 0",
          display: "flex",
          flexDirection: "column",
          zIndex: 2000,
        }}
        wrapStyle={{ zIndex: 2000 }}
        bodyStyle={{
          padding: 0,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div className="modalHeader">
          <span className="modalTitle">租期剩余保险费用</span>
          <span className="modalClose" onClick={onClose}>
            ×
          </span>
        </div>
        <div className="modalSummary">合计金额：{totalAmount}元</div>
        <div className="modalBody">
          {loading ? (
            <div className="loadingText">加载中...</div>
          ) : (
            insurances.map((item, index) => (
              <div className="insuranceItem" key={index}>
                <div
                  className="insuranceSummary"
                  onClick={() => this.toggleExpand(index)}
                >
                  <div className="insuranceTypeRow">
                    <span className="insuranceType">{item.type || "-"}</span>
                    <span
                      className={`expandIcon ${expandedIndex === index ? "expanded" : ""}`}
                    ></span>
                  </div>
                  <div className="insurancePeriod">
                    <span className="periodLabel">保险期限：</span>
                    <span className="periodValue">
                      {item.periodStart || "-"} 至 {item.periodEnd || "-"}
                    </span>
                  </div>
                </div>
                {expandedIndex === index && (
                  <div className="insuranceDetail">
                    <div className="detailRow">
                      <span className="detailLabel">付款方式：</span>
                      <span className="detailValue">
                        {item.paymentMethod || "-"}
                      </span>
                    </div>
                    <div className="detailRow">
                      <span className="detailLabel">保单号：</span>
                      <span className="detailValue">
                        {item.policyNo || "-"}
                      </span>
                    </div>
                    <div className="detailRow">
                      <span className="detailLabel">交付日期：</span>
                      <span className="detailValue">
                        {item.deliveryDate || "-"}
                      </span>
                    </div>
                    <div className="detailRow">
                      <span className="detailLabel">计划还车日期：</span>
                      <span className="detailValue">
                        {item.plannedReturnDate || "-"}
                      </span>
                    </div>
                    <div className="detailRow">
                      <span className="detailLabel">实际保单金额(元)：</span>
                      <span className="detailValue">
                        {item.actualPolicyAmount != null
                          ? item.actualPolicyAmount
                          : "-"}
                      </span>
                    </div>
                    <div className="detailRow">
                      <span className="detailLabel">实际投保天数：</span>
                      <span className="detailValue">
                        {item.actualInsuredDay != null
                          ? item.actualInsuredDay
                          : "-"}
                      </span>
                    </div>
                    <div className="detailRow">
                      <span className="detailLabel">实际单日保费(元)：</span>
                      <span className="detailValue">
                        {item.actualDailyPremium != null
                          ? item.actualDailyPremium
                          : "-"}
                      </span>
                    </div>
                    <div className="detailRow">
                      <span className="detailLabel">保险覆盖租期天数：</span>
                      <span className="detailValue">
                        {item.coverageDays != null ? item.coverageDays : "-"}
                      </span>
                    </div>
                    <div className="detailRow">
                      <span className="detailLabel">应付保险费用(元)：</span>
                      <span className="detailValue">
                        {item.payableInsuranceFee != null
                          ? item.payableInsuranceFee
                          : "-"}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </Modal>
    );
  }
}

export default InsuranceDetailModal;



// WEBPACK FOOTER //
// ./src/processReview/modules/types/CAR_PURCHASE_LIST/insuranceDetailModal/index.js